import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, Typography } from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { formStyles } from '../ClaimCMS1500Form.styles';
import { ClaimCheckbox, ClaimTextField } from '../fields';

export const Box20_OutsideLab: React.FC = () => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Box display="flex" gap={1} flexWrap="wrap">
        <Box display="flex" flexDirection="column" gap={1}>
          <Typography variant="caption">20. OUTSIDE LAB?</Typography>
          <Controller
            name="outsideLab"
            control={control}
            render={({ field, fieldState }) => (
              <ClaimCheckbox
                field={field}
                fieldState={fieldState}
                label="YES"
              />
            )}
          />
        </Box>
        <Box display="flex" flexDirection="column" gap={1} flex={1}>
          <Typography variant="caption" sx={{ textAlign: 'right' }}>
            $ CHARGES
          </Typography>
          <Controller
            name="outsideLabCharges"
            control={control}
            render={({ field, fieldState }) => (
              <ClaimTextField
                field={field}
                fieldState={fieldState}
                size="small"
                placeholder="0.00"
                fullWidth
                sx={formStyles.amountField}
              />
            )}
          />
        </Box>
      </Box>
    </>
  );
};